import { format, type Locale } from 'date-fns';
import { DATE_FORMAT_SHORT } from '../config';

export const formatPeriodLabel = ({
  locale,
  dateFormat = DATE_FORMAT_SHORT,
  dateFrom,
  dateTo,
  defaultLabel,
}: {
  locale: Locale;
  dateFormat?: string;
  dateFrom?: Date;
  dateTo?: Date;
  defaultLabel?: string;
}) => {
  const formatDate = (date: Date) => format(date, dateFormat, { locale });

  if (dateFrom && dateTo) {
    if (dateFrom.getTime() === dateTo.getTime()) {
      return formatDate(dateFrom);
    }
    return `${formatDate(dateFrom)} - ${formatDate(dateTo)}`;
  }

  if (dateFrom) return formatDate(dateFrom);

  if (dateTo) return formatDate(dateTo);

  return defaultLabel || '';
};
